import { useMemo, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { TAB_NAMES } from "src/apps/common/menu-navigation/menuNavigation";
import TabHeader from "src/apps/common/tab-header/TabHeader";
import ReactTable from "src/components/tables/react-table/ReactTable";
import { handleCsvExport } from "src/helpers/helpers";
import useDebounce from "src/hooks/useDebounce";
import useManualRefresh from "src/hooks/useManualRefresh";
import useSetActiveTab from "src/hooks/useSetActiveTab";
import { getActiveApp } from "src/redux/selectors/app";
import { useGetProcurements } from "../api-procurements";
import useProcurementTableColumns from "./useProcurementTableColumns";

const ProcurementsList = () => {
  useSetActiveTab(TAB_NAMES.PROCUREMENT_REQUEST);
  const navigate = useNavigate();
  const [length, setLength] = useState(10);
  const [page, setPage] = useState(1);
  const [searchText, setSearchText] = useState("");
  const debouncedSearch = useDebounce(searchText);
  const activeApp = useSelector(getActiveApp);
  const {
    isLoading,
    error,
    data,
    mutate: updateProcurementData,
    isValidating,
  } = useGetProcurements({ length, page, search: debouncedSearch });
  const { isRefreshing, handleRefresh } = useManualRefresh(
    updateProcurementData
  );

  const procurementData = useMemo(() => data?.data?.rows ?? [], [data?.data]);

  const totalRecords = useMemo(() => data?.data?.count, [data?.data?.count]);

  const columns = useProcurementTableColumns();

  return (
    <>
      <div className="flex flex-col gap-[20px]">
        <TabHeader
          label="Procurement Request"
          onRefresh={() => handleRefresh()}
          exportButton={{
            label: "Export",
            onClick: () => handleCsvExport(procurementData),
          }}
          printButton={{
            label: "Print",
            onClick: () => window.print(),
          }}
          {...(activeApp === "STORE" && {
            createButton: {
              label: "Create Request",
              onClick: () => navigate("/store/vendor/vendors/"),
            },
          })}
          search={{
            onChange: (val) => setSearchText(val),
            value: searchText,
          }}
        />
        <ReactTable
          columns={columns}
          data={procurementData}
          isLoading={isLoading || isRefreshing}
          pagination={{
            setLength,
            length,
            total: totalRecords,
            page,
            setPage,
          }}
        />
      </div>
    </>
  );
};

export default ProcurementsList;
